import { render, staticRenderFns } from "./SfxSearch.vue?vue&type=template&id=29a023e0"
import script from "./SfxSearch.vue?vue&type=script&lang=js"
export * from "./SfxSearch.vue?vue&type=script&lang=js"
import style0 from "./SfxSearch.vue?vue&type=style&index=0&id=29a023e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports